/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Provisioning_ManualInputs */



/**
* | output |
* | --- |
* | "Added manually" |
*
* @param {Member_Detail_Provisioning_ManualInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_provisioning_manual = /** @type {((inputs?: Member_Detail_Provisioning_ManualInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Provisioning_ManualInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuell hinzugefügt")
	return /** @type {LocalizedString} */ ("Added manually")
});